import {Box} from '@mantine/core';
import Link from 'next/link';
import type React from 'react';
import {
  INTERN,
  type UserMeClipType,
} from '../../../../core/entities/clip/constants';
import {getFavoriteButtonComponent} from '../../../../shared/services/getFavoriteButtonComponent';
import {getResourceLinkType} from '../../../../shared/services/getResourceLinkType';
import {ClipListBase} from './ClipListBase';
import type {IClipContentProps, IClipListProps} from './ClipListInterfaces';

const CLipLabel: React.FC<{label: string}> = ({label}) => (
  <>
    {label === INTERN.JP && (
      <span className="rounded-2 h-18 mr-8 mt-4 min-w-[70px] bg-black-3 px-8 text-center text-xs leading-[18px] text-white">
        {label}
      </span>
    )}
  </>
);

const CLipHashTag: React.FC<{hashtags: string[] | undefined}> = ({
  hashtags,
}) => (
  <>
    {hashtags?.map((tag, i) => (
      <span
        key={`${tag}-${i}`}
        className="rounded-2 h-18 mr-8 mt-4 min-w-[70px] bg-black-3 px-8 text-center text-xs leading-[18px] text-white"
      >
        {tag}
      </span>
    ))}
  </>
);

const ClipContentForMobile: React.FC<IClipContentProps> = ({clip}) => {
  const FavoriteButtonComponent = getFavoriteButtonComponent(
    clip.type as UserMeClipType,
  );
  const resourceLinkType = getResourceLinkType(clip.type as UserMeClipType);

  return (
    <li className="w-full border-b-[1px] border-solid border-background-3 px-16 py-12">
      <Box className="flex flex-wrap">
        <CLipLabel label={clip.label} />
        <CLipHashTag hashtags={clip.hashtags ?? undefined} />
      </Box>
      <Box className="flex items-end justify-between">
        <Link
          href={`/${resourceLinkType}/${clip.content.id}`}
          className="mr-12 mt-4 block text-left text-base font-bold leading-sm text-black-1"
        >
          {clip.content.title}
        </Link>
        <FavoriteButtonComponent clip={clip} />
      </Box>
    </li>
  );
};

export const ClipListForMobile: React.FC<IClipListProps> = (props) => (
  <ClipListBase {...props} ClipContentComponent={ClipContentForMobile} />
);
